/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { CompositeFilter } from './compositeFilter.schema';
import { FilterDescriptor } from './filterDescriptor.schema';

export type IFilterBase = FilterDescriptor | CompositeFilter;

export const IFilterBase: zod.ZodType<IFilterBase> = zod.union([zod.lazy(() => FilterDescriptor),zod.lazy(() => CompositeFilter)]);

export type IFilterBaseOutput = zod.output<typeof IFilterBase>;
